<app-title-bar titleText="i18n.core.navigation.home"></app-title-bar>
<div class="home">
  <img class="home_logo" src="../../../assets/img/logo.svg">
</div>
